import * as React from "react";
import { styled } from "theme";
import { motion } from "framer-motion";
import { IconButton } from "@chakra-ui/core";
import config from "../../config";
import CubeImage from "./CubeImage";

export interface Props {
  onClose: () => void;
  codes: string[];
}

var _count = 0;

export default function Preview({ onClose, codes }: Props) {
  const [sources, setSources] = React.useState<string[]>([]);

  React.useEffect(() => {
    if (codes.length === 11) {
      let f1 = "";
      if (codes.includes(config.viltDark)) {
        f1 = `/_clientfiles/assets/cubes/alles_donkergrijs.jpg`;
      } else {
        f1 = `/_clientfiles/assets/cubes/alles_lichtgrijs.jpg`;
      }

      setSources((old) => [...old, f1]);
    } else {
      let used = codes.filter((c) => {
        if (c === config.viltLight || c === config.viltDark) return true;
        return config.include.includes(c);
      });
      used = sortAlpha(used);

      let filename = `/_clientfiles/assets/cubes/${used.join("_")}.jpg`;
      if (used.length === 0) {
        filename = "/_clientfiles/assets/cubes/DCV01.jpg";
      }

      if (sources[sources.length - 1] !== filename) {
        setSources((old) => [...old, filename]);
      }
    }
  }, [codes]);

  const gc = () => {
    if (sources.length > 1) {
      setSources((old) => [old[old.length - 1]]);
    }
  };

  return (
    <PreviewContainer
      key="preview"
      initial={{
        translateY: "-50%"
      }}
      animate={{
        translateY: 0
      }}
      exit={{
        translateY: "-100%"
      }}
    >
      {/* <Debug>
        {sources.map((s, n) => (
          <div key={n}>{s}</div>
        ))}
      </Debug> */}
      <ImageContainer>
        {sources.map((src, n) => (
          <CubeImage
            key={n}
            src={src}
            count={_count++}
            done={() => {
              gc();
            }}
          />
        ))}
      </ImageContainer>

      <IconButton
        className="close-button"
        aria-label="close"
        icon="small-close"
        isRound={true}
        size="sm"
        onClick={() => {
          window.location.href = "/";
        }}
      />
    </PreviewContainer>
  );
}

function sortAlpha(codes: string[]): string[] {
  return codes.sort((a, b) => {
    return ("" + a).localeCompare("" + b);
  });
}

const _Preview = styled.div`
  position: absolute;
  left: 40%;
  top: 0;
  width: 60%;
  height: 70%;
  background-color: #eee;
  .close-button {
    position: absolute;
    right: 16px;
    top: 16px;
    z-index: 999;
  }
  @media (max-width: 600px) {
    left: 0;
    width: 100%;
    height: 30%;

    .close-button {
      right: 8px;
      top: 8px;
    }
  }
`;
const PreviewContainer = motion.custom(_Preview);

const ImageContainer = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;

  background-color: #322f2a;
`;

// const Debug = styled.div`
//   position: absolute;
//   z-index: 1000;
//   left: 0;
//   bottom: 0;
//   width: 100%;
//   height: 300px;
//   color: #fff;
// `;
